export default "/images/vendor/flag-icon-css/flags/4x3/ca.svg?d348137a99e6d528c5b7ffec1e05488a";